module.exports = __webpack_public_path__ + "img/zu12.c37922c9.svg";